import React from "react";
import cv_basketball from "../../../Assets/Images/cv-basketball1.png";
import cv_soccer from "../../../Assets/Images/cv-soccer1.png";
import cv_football from "../../../Assets/Images/cv-football1.png";
import cv_track_and_field from "../../../Assets/Images/cv-track-and-field1.png";
import cv_fitness from "../../../Assets/Images/cv-fitness1.png";
import basket_ball from "../../../Assets/Images/Basketball/after-sc-baslet.png";
import soccer from "../../../Assets/Images/Basketball/after--sc-grp3.png";
import football from "../../../Assets/Images/Basketball/after--sc-grp2.png";
import trackfield from "../../../Assets/Images/Basketball/after--sc-grp1.png";
import fitness from "../../../Assets/Images/Basketball/after--sc-grp.png";

import "./choosevariety.css";
export default function ChooseVariety() {
  return (
    <>
      <div className="variety-container">
        <div className="variety-header">
          <h2 className="black-text-clip">Why Choose Us?</h2>
        </div>
        <div className="variety-description">
          <p className="black-text-clip">
            At Because We Can, we believe in the power of sports to inspire and
            empower children. Our afterschool program is more than just a place
            to play sports; it’s a community where children can thrive, learn,
            and have fun. Join us and give your child the opportunity to
            experience the joy of sports, make new friends, and develop a
            lifelong love for physical activity.
          </p>
          <p className="black-text-clip">
            <strong>
              Our After School Program costs $600 per hour. Two specialists will
              be assigned per 30 players that participate.
            </strong>
          </p>
        </div>
        <p className="variety-usp black-text-clip">
          Choose from a variety of sports that include:
        </p>
      </div>
      <div className="asp-image-container cv">
        <div className="image-container cv-item">
          <img src={basket_ball} alt="Sample Image" />
          {/* <div className="overlay">
            <p className="overlay-text"></p>
          </div> */}
        </div>
        <div className="image-container cv-item">
          <img src={soccer} alt="Sample Image" />
        </div>
        <div className="image-container cv-item">
          <img src={football} alt="Sample Image" />
        </div>
        <div className="image-container cv-item">
          <img src={trackfield} alt="Sample Image" />
        </div>
        <div className="image-container cv-item">
          <img src={fitness} alt="Sample Image" />
        </div>
      </div>
    </>
  );
}
